// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.site-switcher[data-v-55d58d7e] {
  display: inline-block;
}
.site-btn[data-v-55d58d7e] {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  color: #333;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}
.site-btn[data-v-55d58d7e]:hover {
  background: rgba(255, 255, 255, 1);
  border-color: rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}
.site-btn i[data-v-55d58d7e] {
  font-size: 12px;
}
.site-icon[data-v-55d58d7e] {
  font-size: 16px;
}
.site-item[data-v-55d58d7e] {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}
.site-details[data-v-55d58d7e] {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.site-name[data-v-55d58d7e] {
  font-weight: 500;
  font-size: 14px;
  color: #333;
}
.site-url[data-v-55d58d7e] {
  font-size: 12px;
  color: #666;
  font-family: 'Courier New', monospace;
}
.site-status[data-v-55d58d7e] {
  display: flex;
  align-items: center;
}
.current-badge[data-v-55d58d7e] {
  background: #28a745;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
}
.switch-icon[data-v-55d58d7e] {
  color: #666;
  font-size: 12px;
}
[data-v-55d58d7e] .el-dropdown-menu__item {
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
}
[data-v-55d58d7e] .el-dropdown-menu__item:hover {
  background-color: #f0f2f5;
}
[data-v-55d58d7e] .el-dropdown-menu__item.current-site {
  background-color: #e8f5e8;
  color: #28a745;
}
[data-v-55d58d7e] .el-dropdown-menu__item.current-site:hover {
  background-color: #d4edda;
}
[data-v-55d58d7e] .el-dropdown-menu {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  min-width: 280px;
}

/* 确认对话框样式 */
.confirm-dialog-overlay[data-v-55d58d7e] {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.confirm-dialog[data-v-55d58d7e] {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}
.confirm-header h4[data-v-55d58d7e] {
  margin: 0 0 1rem 0;
  color: #333;
  font-size: 1.1rem;
  font-weight: 600;
}
.confirm-content[data-v-55d58d7e] {
  margin-bottom: 1.5rem;
}
.confirm-content p[data-v-55d58d7e] {
  margin: 0 0 1rem 0;
  color: #666;
  line-height: 1.5;
}
.site-preview[data-v-55d58d7e] {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #007bff;
}
.site-preview .site-icon[data-v-55d58d7e] {
  color: #007bff;
}
.site-preview span[data-v-55d58d7e] {
  font-weight: 600;
  color: #333;
}
.site-preview small[data-v-55d58d7e] {
  color: #666;
  font-family: 'Courier New', monospace;
  margin-left: auto;
}
.confirm-actions[data-v-55d58d7e] {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}
.btn-cancel[data-v-55d58d7e], .btn-confirm[data-v-55d58d7e] {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.btn-cancel[data-v-55d58d7e] {
  background: #6c757d;
  color: white;
}
.btn-cancel[data-v-55d58d7e]:hover {
  background: #5a6268;
}
.btn-confirm[data-v-55d58d7e] {
  background: #007bff;
  color: white;
}
.btn-confirm[data-v-55d58d7e]:hover:not(:disabled) {
  background: #0056b3;
}
.btn-confirm[data-v-55d58d7e]:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.btn-confirm i[data-v-55d58d7e] {
  margin-right: 0.5rem;
}

/* 响应式设计 */
@media (max-width: 480px) {
.confirm-dialog[data-v-55d58d7e] {
    margin: 1rem;
    padding: 1rem;
}
.site-item[data-v-55d58d7e] {
    gap: 8px;
}
.site-name[data-v-55d58d7e] {
    font-size: 13px;
}
.site-url[data-v-55d58d7e] {
    font-size: 11px;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/SiteSwitcher.vue"],"names":[],"mappings":";AA6HA;EACE,qBAAqB;AACvB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,2BAA2B;AAC7B;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,0CAA0C;EAC1C,2BAA2B;AAC7B;AAEA;EACE,eAAe;AACjB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AAEA;EACE,eAAe;EACf,WAAW;EACX,qCAAqC;AACvC;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,WAAW;EACX,eAAe;AACjB;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;EACpC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,0CAA0C;AAC5C;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;AAEA;EACE,cAAc;AAChB;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AAEA;EACE,oBAAoB;AACtB;;AAEA,UAAU;AACV;AACE;IACE,YAAY;IACZ,aAAa;AACf;AAEA;IACE,QAAQ;AACV;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AACF","sourcesContent":["<template>\n  <div class=\"site-switcher\">\n    <el-dropdown @command=\"handleSiteSwitch\" trigger=\"click\">\n      <button class=\"site-btn\">\n        <i :class=\"currentSiteIcon\"></i>\n        <span>{{ currentSiteName }}</span>\n        <i class=\"fas fa-chevron-down\"></i>\n      </button>\n      <template #dropdown>\n        <el-dropdown-menu>\n          <el-dropdown-item \n            v-for=\"site in allSites\" \n            :key=\"site.id\"\n            :command=\"site.id\"\n            :disabled=\"site.id === currentSiteId\"\n            :class=\"{ 'current-site': site.id === currentSiteId }\"\n          >\n            <div class=\"site-item\">\n              <i :class=\"site.icon\" class=\"site-icon\"></i>\n              <div class=\"site-details\">\n                <div class=\"site-name\">{{ getSiteDisplayName(site.id) }}</div>\n                <div class=\"site-url\">{{ site.url }}</div>\n              </div>\n              <div class=\"site-status\">\n                <span v-if=\"site.id === currentSiteId\" class=\"current-badge\">{{ t('common.status') }}</span>\n                <i v-else class=\"fas fa-arrow-right switch-icon\"></i>\n              </div>\n            </div>\n          </el-dropdown-item>\n        </el-dropdown-menu>\n      </template>\n    </el-dropdown>\n\n    <!-- 确认对话框 -->\n    <div v-if=\"showConfirmDialog\" class=\"confirm-dialog-overlay\" @click=\"cancelSwitch\">\n      <div class=\"confirm-dialog\" @click.stop>\n        <div class=\"confirm-header\">\n          <h4>{{ t('siteSwitcher.switchSite') }}</h4>\n        </div>\n        <div class=\"confirm-content\">\n          <p>{{ t('siteSwitcher.switchConfirm', { site: targetSite?.name }) }}</p>\n          <div class=\"site-preview\">\n            <i :class=\"targetSite?.icon\" class=\"site-icon\"></i>\n            <span>{{ targetSite?.name }}</span>\n            <small>{{ targetSite?.url }}</small>\n          </div>\n        </div>\n        <div class=\"confirm-actions\">\n          <button class=\"btn-cancel\" @click=\"cancelSwitch\">\n            {{ t('common.cancel') }}\n          </button>\n          <button class=\"btn-confirm\" @click=\"confirmSwitch\" :disabled=\"isSwitching\">\n            <i v-if=\"isSwitching\" class=\"fas fa-spinner fa-spin\"></i>\n            {{ isSwitching ? t('siteSwitcher.switching') : t('common.confirm') }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<script setup>\nimport { ref, computed } from 'vue';\nimport { useI18n } from 'vue-i18n';\nimport { useSiteSwitcher } from '../composables/useSiteSwitcher.js';\n\nconst { t } = useI18n();\nconst {\n  currentSiteId,\n  allSites,\n  isSwitching,\n  switchToSite,\n  getSiteDisplayName,\n  getSiteIcon\n} = useSiteSwitcher();\n\n// 响应式数据\nconst showConfirmDialog = ref(false);\nconst targetSite = ref(null);\n\n// 当前站点名称和图标（使用国际化）\nconst currentSiteName = computed(() => {\n  const locale = t('language.en') === 'English' ? 'en' : \n                 t('language.zh') === '中文' ? 'zh' : 'ja';\n  return getSiteDisplayName(currentSiteId.value, locale);\n});\n\nconst currentSiteIcon = computed(() => getSiteIcon(currentSiteId.value));\n\n// 处理站点切换\nconst handleSiteSwitch = (siteId) => {\n  if (siteId === currentSiteId.value) {\n    return; // 已经是当前站点\n  }\n  \n  const site = allSites.value.find(s => s.id === siteId);\n  if (!site) return;\n  \n  targetSite.value = site;\n  showConfirmDialog.value = true;\n};\n\n// 确认切换\nconst confirmSwitch = async () => {\n  if (!targetSite.value) return;\n  \n  try {\n    await switchToSite(targetSite.value.id, {\n      delay: 500, // 延迟500ms让用户看到切换状态\n      saveState: true\n    });\n  } catch (error) {\n    console.error('Site switch failed:', error);\n    alert(t('siteSwitcher.switchFailed'));\n  }\n};\n\n// 取消切换\nconst cancelSwitch = () => {\n  showConfirmDialog.value = false;\n  targetSite.value = null;\n};\n</script>\n\n<style scoped>\n.site-switcher {\n  display: inline-block;\n}\n\n.site-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  color: #333;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n}\n\n.site-btn:hover {\n  background: rgba(255, 255, 255, 1);\n  border-color: rgba(0, 0, 0, 0.2);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transform: translateY(-1px);\n}\n\n.site-btn i {\n  font-size: 12px;\n}\n\n.site-icon {\n  font-size: 16px;\n}\n\n.site-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.site-details {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.site-name {\n  font-weight: 500;\n  font-size: 14px;\n  color: #333;\n}\n\n.site-url {\n  font-size: 12px;\n  color: #666;\n  font-family: 'Courier New', monospace;\n}\n\n.site-status {\n  display: flex;\n  align-items: center;\n}\n\n.current-badge {\n  background: #28a745;\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 500;\n}\n\n.switch-icon {\n  color: #666;\n  font-size: 12px;\n}\n\n:deep(.el-dropdown-menu__item) {\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n:deep(.el-dropdown-menu__item:hover) {\n  background-color: #f0f2f5;\n}\n\n:deep(.el-dropdown-menu__item.current-site) {\n  background-color: #e8f5e8;\n  color: #28a745;\n}\n\n:deep(.el-dropdown-menu__item.current-site:hover) {\n  background-color: #d4edda;\n}\n\n:deep(.el-dropdown-menu) {\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  min-width: 280px;\n}\n\n/* 确认对话框样式 */\n.confirm-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.confirm-dialog {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.confirm-header h4 {\n  margin: 0 0 1rem 0;\n  color: #333;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.confirm-content {\n  margin-bottom: 1.5rem;\n}\n\n.confirm-content p {\n  margin: 0 0 1rem 0;\n  color: #666;\n  line-height: 1.5;\n}\n\n.site-preview {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border-left: 3px solid #007bff;\n}\n\n.site-preview .site-icon {\n  color: #007bff;\n}\n\n.site-preview span {\n  font-weight: 600;\n  color: #333;\n}\n\n.site-preview small {\n  color: #666;\n  font-family: 'Courier New', monospace;\n  margin-left: auto;\n}\n\n.confirm-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n}\n\n.btn-cancel, .btn-confirm {\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-cancel {\n  background: #6c757d;\n  color: white;\n}\n\n.btn-cancel:hover {\n  background: #5a6268;\n}\n\n.btn-confirm {\n  background: #007bff;\n  color: white;\n}\n\n.btn-confirm:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n.btn-confirm:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-confirm i {\n  margin-right: 0.5rem;\n}\n\n/* 响应式设计 */\n@media (max-width: 480px) {\n  .confirm-dialog {\n    margin: 1rem;\n    padding: 1rem;\n  }\n  \n  .site-item {\n    gap: 8px;\n  }\n  \n  .site-name {\n    font-size: 13px;\n  }\n  \n  .site-url {\n    font-size: 11px;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
